var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Delete Installation ")]
          ),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "px-2",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _vm.installation
                        ? _c(
                            "p",
                            {
                              staticClass: "mb-0"
                            },
                            [
                              _vm._v(
                                " This will delete your " +
                                  _vm._s(_vm.appName) +
                                  " installation for " +
                                  _vm._s(_vm.installation.softdomain) +
                                  ". "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "px-5 pt-0 pb-3 justify-content-end"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.deleteInstallation
                  }
                },
                [_vm._v("Delete")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }